export default "__VITE_ASSET__BafjN5Uo__"